import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Search",
  "use": "svg-icon-Search-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.966 8.404a3.442 3.442 0 0 1-3.438-3.438 3.442 3.442 0 0 1 3.438-3.438 3.442 3.442 0 0 1 3.438 3.438 3.442 3.442 0 0 1-3.438 3.438zm6.68 2.87a.5.5 0 0 0 0-.708L8.971 7.89c.601-.822.96-1.83.96-2.924A4.972 4.972 0 0 0 4.967 0 4.972 4.972 0 0 0 0 4.966a4.972 4.972 0 0 0 4.966 4.966c1.094 0 2.102-.36 2.924-.961l2.676 2.675a.5.5 0 0 0 .707 0l.373-.373z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol